.header {
  margin-bottom: 10px;
}

.editColumnContainer {
  .editColumnTitle {
    color: var(--bc-color-text);
    font-size: 20px;
    font-weight: bold;
  }

  .checkboxTitle {
    font-size: 14px;
    letter-spacing: 0;
    line-height: 14px;
  }

  .editColumnGroup {
    padding: 12px 0;

    &:last-child {
      padding-bottom: 36px;
    }

    &:not(:last-child) {
      border-bottom: 1px solid var(--bc-color-split);
    }

    > span {
      margin-right: 10px;
    }

    .groupTitle {
      margin-bottom: 16px;
    }

    .groupItemsContainer {
      padding: 12px 0 0 28px;
      display: flex;

      .groupItems {
        display: flex;
        flex-wrap: wrap;

        label {
          margin: 0 20px 10px 0 !important;
        }
      }
    }

    .divider {
      width: 8px;
      border-left: 1px solid var(--bc-color-text-secondary);
      border-bottom: 1px solid var(--bc-color-text-secondary);
      margin: 0 10px 10px 0;
    }
  }

  .editColumnFooter {
    position: absolute;
    bottom: 0px;
    left: 24px;
    right: 24px;
    background: var(--bc-color-bg-container);
    padding: 12px 0;
    button {
      margin-left: 8px;
    }
  }

  :global {
    .ant-form-item-label {
      font-family: var(--bc-font-family);
      font-weight: 700;
      line-height: 24px;
    }
  }

  .resetContainer {
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-end;
  }
}
